/* =============================================================================
   TBO CRO PACK - 2026-08-29, offer retargeted 2026-09-07
   Ships four fixes. Each is independently guarded so a failure in one cannot
   take down the others, and none of them touch checkout.

     1. SEARCHANISE -> CART DRAWER BRIDGE          (audit P1-02)
     2. VINTAGE SUBSTITUTION PERSISTENCE           (audit P1-03)
     3. BASKET PROGRESS BAR - $15 off over $225     (audit P1-05)
     4. CART SUMMARY REORDER HOOK                  (audit P2-09, CSS does the work)

   ROLLBACK = delete this file and its <script> tag in layout/theme.liquid.
   Nothing else in the theme depends on it.
   ============================================================================= */
(function () {
  'use strict';

  // OFFER_ENABLED gates the basket progress bar in section 3 below.
  //
  // 2026-08-29: set to FALSE. "Free shipping over $175" was paused while the
  // shipping rate card was rebuilt against real WeShip/Advatix cost data.
  //
  // 2026-09-07: set to TRUE and repointed. Free shipping over $175 is retired -
  // it lost $15.12 on a $175 basket and did not break even until $381 once the
  // 3.08x MER was loaded, and its $30 maximumShippingPrice was a QUALIFYING GATE
  // rather than a credit, so it silently never fired on any basket over 15 lb
  // (a $175 wine order is ~22 lb and rated $46.95). The single live offer is now
  // the "$15 off orders over $225" automatic discount, which fires on any weight.
  //
  // The threshold here MUST match that discount's minimum. If the discount moves,
  // move this number in the same change or the bar starts lying.
  // assets/tbo-offer-bar-config.js sets window.TBO_OFFER and is the intended
  // single source of truth. It is only read if a <script> tag for it has been
  // added to layout/theme.liquid ABOVE this file; until then these fallbacks
  // are what ship, and the two must be kept in step.
  var CFG = (typeof window !== 'undefined' && window.TBO_OFFER) || {};
  var OFFER_ENABLED = CFG.ENABLED !== undefined ? CFG.ENABLED : true;
  var OFFER_THRESHOLD = CFG.THRESHOLD_CENTS || 22500; // cents - "$15 off over $225"
  var OFFER_LABEL = CFG.LABEL || '$15 off';

  function log(area, err) {
    if (window.console && console.warn) console.warn('[tbo-cro] ' + area, err);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------------------------------------------------------------------------
     1. SEARCHANISE -> CART DRAWER BRIDGE

     Searchanise renders the collection and search grids. Its own add-to-cart
     button posts the item, then relabels itself "View Cart" and does nothing
     else: no drawer, no toast, and no way to add a second unit without leaving
     the page. Measured desktop add-to-cart was 3.2% against mobile's 6.2%.

     We intercept the click in the capture phase and stop it reaching
     Searchanise's handler, then run Dawn's own add-to-cart flow so the theme
     cart drawer opens exactly as it does from a product page.

     Products with more than one purchasable variant are NOT added blind - the
     shopper goes to the product page to choose. Guessing a variant is how you
     ship someone a 750ml when they wanted the 1.75L.
  --------------------------------------------------------------------------- */
  function initSearchaniseBridge() {
    var BTN = '.snize-add-to-cart-button';

    document.addEventListener('click', function (evt) {
      var btn = evt.target && evt.target.closest && evt.target.closest(BTN);
      if (!btn) return;

      var drawer = document.querySelector('cart-drawer');
      // No drawer on the page means the theme is in "cart page" mode. Leave
      // Searchanise alone rather than half-handling the click.
      if (!drawer || typeof drawer.renderContents !== 'function') return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      if (btn.dataset.tboBusy === '1') return;
      btn.dataset.tboBusy = '1';

      var originalLabel = btn.textContent;
      btn.textContent = 'Adding...';

      addFromCard(btn, drawer)
        .catch(function (err) { log('searchanise-bridge', err); })
        .then(function () {
          btn.textContent = originalLabel;
          delete btn.dataset.tboBusy;
        });
    }, true); // capture, so we run before Searchanise
  }

  function addFromCard(btn, drawer) {
    var card = btn.closest('.snize-product') || btn.closest('[data-original-product-id]');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return Promise.reject(new Error('no product link on card'));

    var href = link.getAttribute('href');
    var handle = href.split('/products/')[1].split(/[?#]/)[0];

    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var available = (product.variants || []).filter(function (v) { return v.available; });

        if (available.length === 0) { window.location.href = href; return; }
        // Let the shopper pick when there is a real choice to make.
        if (available.length > 1) { window.location.href = href; return; }

        var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: available[0].id, quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            // Shopify returns a status field on error (e.g. inventory ran out
            // between page render and click).
            if (state.status) { window.location.href = href; return; }
            drawer.renderContents(state);
            document.dispatchEvent(new CustomEvent('tbo:cart:updated'));
          });
      });
  }

  /* ---------------------------------------------------------------------------
     2. VINTAGE SUBSTITUTION PERSISTENCE

     The radios are name="attributes[Vintage Substitution]" inside the theme's
     <form action="/cart">. Shopify only writes cart attributes when that form
     is submitted, and this cart updates over AJAX, so the form never submits.
     Verified live: clicking a radio left cart.attributes as {_heatVid}, and the
     last 10 orders carried no such attribute. A customer who asked to be
     contacted before a substitution was never recorded as asking.

     Fix: write the attribute on change. Pre-select the low-friction option so
     the cart is never in an unanswered state. Hide the block entirely unless
     the cart actually contains wine - a bourbon-and-beer buyer should not be
     asked about vintages.
  --------------------------------------------------------------------------- */
  var VINTAGE_NAME = 'attributes[Vintage Substitution]';

  function vintageRadios() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[type="radio"][name="' + VINTAGE_NAME + '"]')
    );
  }

  function vintageBlock() {
    var first = vintageRadios()[0];
    if (!first) return null;
    // Walk up to the wrapper that also holds the "Vintage Substitution?" label.
    var node = first.parentElement;
    for (var i = 0; i < 5 && node; i++) {
      if (/vintage substitution/i.test(node.textContent || '')) return node;
      node = node.parentElement;
    }
    return first.parentElement;
  }

  function saveVintage(value) {
    var attrs = {};
    attrs['Vintage Substitution'] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function (err) { log('vintage-save', err); });
  }

  function initVintage(cart) {
    var radios = vintageRadios();
    if (!radios.length) return;

    var block = vintageBlock();
    var hasWine = (cart.items || []).some(function (item) {
      var type = (item.product_type || '').toLowerCase();
      return type.indexOf('wine') !== -1 ||
             type.indexOf('champagne') !== -1 ||
             type.indexOf('sparkling') !== -1 ||
             type === 'red' || type === 'white' || type === 'rose';
    });

    if (!hasWine) {
      if (block) block.style.display = 'none';
      return;
    }
    if (block) block.style.display = '';

    var saved = (cart.attributes || {})['Vintage Substitution'];

    if (saved) {
      radios.forEach(function (r) { r.checked = (r.value === saved); });
    } else if (!radios.some(function (r) { return r.checked; })) {
      // Default to "a newer vintage is fine" so no order stalls on an
      // unanswered question, and record it so the order carries the answer.
      radios[0].checked = true;
      saveVintage(radios[0].value);
    }

    radios.forEach(function (radio) {
      if (radio.dataset.tboBound === '1') return;
      radio.dataset.tboBound = '1';
      radio.addEventListener('change', function () {
        if (radio.checked) saveVintage(radio.value);
      });
    });
  }

  /* ---------------------------------------------------------------------------
     3. BASKET PROGRESS BAR

     Shows the shopper how far they are from the live offer while the basket is
     still editable, instead of springing it on them at checkout step two - which
     is what a 25.3% checkout completion rate looks like.

     2026-09-07: retargeted from "free shipping over $175" to "$15 off over $225".
     AOV is running $77-116, so $225 is a genuine stretch and this bar is the only
     thing on the site that tells a shopper the stretch is worth making. Break-even
     on the offer is $204.57, so every basket this bar pushes over $225 clears.

     Rendered into both the cart drawer and the cart page, above the checkout
     button in both.
  --------------------------------------------------------------------------- */
  function renderFreeShipBar(cart) {
    if (!OFFER_ENABLED) {
      // Offer is paused. Remove any bar a previous render left behind so the
      // shopper is never shown a threshold that will not be honoured.
      Array.prototype.forEach.call(
        document.querySelectorAll('.tbo-freeship'),
        function (el) { el.parentElement.removeChild(el); }
      );
      return;
    }

    var mounts = [
      document.querySelector('.cart-drawer .cart__ctas'),
      document.querySelector('#main-cart-footer .cart__ctas')
    ].filter(Boolean);

    mounts.forEach(function (ctas) {
      var bar = ctas.parentElement.querySelector('.tbo-freeship');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'tbo-freeship';
        bar.innerHTML =
          '<p class="tbo-freeship__msg"></p>' +
          '<div class="tbo-freeship__track"><span class="tbo-freeship__fill"></span></div>';
        ctas.parentElement.insertBefore(bar, ctas);
      }

        // 2026-09-24: two live tiers. $15 off $225 (no end date) and $40 off $400 (ends Oct 31).
        // Shopify applies the bigger one, they don't stack. Measured on the pre-discount total so the
        // bar doesn't slip back below a threshold once that discount is applied in the cart.
        var total = cart.original_total_price || cart.total_price || 0;
        var tiers = (CFG.TIERS && CFG.TIERS.length) ? CFG.TIERS : [
          { cents: OFFER_THRESHOLD, label: OFFER_LABEL },
          { cents: 40000, label: '$40 off', until: '2026-11-01T07:00:00Z' }
        ];
        tiers = tiers.filter(function (t) { return !t.until || Date.now() < Date.parse(t.until); });
        var unlocked = null, next = null;
        for (var i = 0; i < tiers.length; i++) {
          if (total >= tiers[i].cents) { unlocked = tiers[i]; } else { next = tiers[i]; break; }
        }
        var pct = next ? Math.min(100, Math.round((total / next.cents) * 100)) : 100;

        var msg = bar.querySelector('.tbo-freeship__msg');
        var fill = bar.querySelector('.tbo-freeship__fill');

        if (total <= 0 || !tiers.length) {
          bar.hidden = true;
          return;
        }
        bar.hidden = false;

        var html;
        if (next && unlocked) {
          html = '<strong>' + unlocked.label + ' unlocked.</strong> Add <strong>' + money(next.cents - total) + '</strong> more for ' + next.label + '.';
        } else if (next) {
          html = 'You are <strong>' + money(next.cents - total) + '</strong> away from ' + next.label + '.';
        } else {
          html = '<strong>' + unlocked.label + ' unlocked.</strong> Applied at checkout.';
        }
        // Only write when the text changes. Unconditional innerHTML writes here fed the drawer observer loop.
        if (msg.getAttribute('data-tbo-html') !== html) {
          msg.innerHTML = html;
          msg.setAttribute('data-tbo-html', html);
        }
        bar.classList.toggle('tbo-freeship--hit', !next);
        fill.style.width = pct + '%';      });
  }

  /* ---------------------------------------------------------------------------
     4. FINE PRINT RELOCATION

     On the cart page the express wallets sat 1,796px down a 3,124px page, with
     three blocks of friction stacked between the total and the buy button:
     two image disclaimers, a tax caveat, and the ZIP eligibility gate.

     CSS `order` can reorder siblings but cannot move a node to a different
     parent, and the disclaimers live inside .js-contents alongside the total.
     So we move them once into a container at the end of the summary. The copy
     is unchanged and still on the page - it just stops sitting in the path.
  --------------------------------------------------------------------------- */
  function relocateFinePrint() {
    var scopes = [
      document.querySelector('#main-cart-footer .cart__blocks'),
      document.querySelector('.cart-drawer .drawer__footer')
    ].filter(Boolean);

    scopes.forEach(function (scope) {
      var notes = scope.querySelectorAll('.note-text, .tax-note');
      if (!notes.length) return;

      var box = scope.querySelector('.tbo-finetext');
      if (!box) {
        box = document.createElement('div');
        box.className = 'tbo-finetext';
        scope.appendChild(box);
      }
      Array.prototype.forEach.call(notes, function (n) {
        if (n.parentElement !== box) box.appendChild(n);
      });
    });
  }

  /* ---------------------------------------------------------------------------
     SHARED CART STATE

     One fetch feeds the vintage block and the shipping bar. Re-run whenever the
     cart changes, including after the drawer re-renders itself.
  --------------------------------------------------------------------------- */
  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        try { relocateFinePrint(); } catch (e) { log('fineprint', e); }
        try { initVintage(cart); } catch (e) { log('vintage', e); }
        try { renderFreeShipBar(cart); } catch (e) { log('freeship', e); }
      })
      .catch(function (err) { log('cart-fetch', err); });
  }

  function watchCartChanges() {
    // Dawn publishes to its own pubsub; the drawer also swaps its innerHTML.
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh); } catch (e) { log('pubsub', e); }
    }
    document.addEventListener('tbo:cart:updated', refresh);

    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var pending = null;
      // 2026-09-24: ignore mutations inside our own bar/fine-print nodes. Without this, renderFreeShipBar's innerHTML
      // write re-triggered this observer, which re-fetched /cart.js about once a second forever for any non-empty cart.
      new MutationObserver(function (muts) {
        var ours = muts.every(function (m) {
          var el = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
          return !!(el && el.closest && el.closest('.tbo-freeship, .tbo-finetext'));
        });
        if (ours) return;
        clearTimeout(pending);
        pending = setTimeout(refresh, 150);
      }).observe(drawer, { childList: true, subtree: true });
    
        }
  }

  function boot() {
    try { initSearchaniseBridge(); } catch (e) { log('bridge-init', e); }
    try { watchCartChanges(); } catch (e) { log('watch-init', e); }
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
